export default {
  //Search
  "Search": "Zoek",
  "What are you looking for?": "Waar ben je naar op zoek?",
  "More results for {inputQuery}": "Meer resultaten voor {inputQuery}",
  "No results found for {inputQuery}": "Geen resultaten gevonden voor {inputQuery}",

  //Header cart
  "Product has been added to cart": "Product toegevoegd aan winkelwagen",
  "Could not add product to cart": "Product kon niet worden toegevoegd. Probeer het opnieuw.",
  "Close": "Sluiten",

  //Newsletter
  "Newsletter subscription": "Aanmelden nieuwsbrief",
  "Your Email address": "Je e-mail adres",
  "Surprise me": "Verras me",

  // Categorie
  "No products were found in this category.": "Er zijn geen producten gevonden.",
  "Product has been added": "Product is toegevoegd",
  "Page": "Pagina",
  "Filter": "Filteren",
  "{fromProducts} to {toProducts} of {totalProductCount} results": "Geen resultaten | 1 resultaat | {fromProducts} tot {toProducts} van {totalProductCount} resultaten",
  "Page {currentPage} of {totalPages}": "Pagina {currentPage} van {totalPages}",
  "Sort by": "Sorteren op",
  "Name (A-Z)": "Naam (A-Z)",
  "Name (Z-A)": "Naam (Z-A)",
  "Price (Ascending)": "Prijs (Oplopend)",
  "Price (Descending)": "Prijs (Aflopend)",
  "All": "Alle",
  "Show {totalItems} results": "Geen resultaten | 1 resultaat | Bekijk {totalItems} resultaten",
  "Show results": "Bekijk resultaten",
  "Active filters": "Actieve filters",
  "Show more": "Toon meer",
  "Show less": "Toon minder",
  "Price": "Prijs",
  "Enter a correct value": "Vul een geldige waarde in",
  "Categories": "Categorieën",
  "Show": "Toon",
  "No products were found.": "Geen producten gevonden",

  //Product
  "Vloeren zijn alleen per pak te bestellen.": "Vloeren zijn alleen per pak te bestellen.",
  "Vloeren zijn alleen per pak te bestellen, kies een andere maat.": "Vloeren zijn alleen per pak te bestellen, kies een andere maat.",
  "There are no available options for this product.": "Er zijn voor dit product geen beschikbare opties gevonden.",
  "Not in stock": "Niet op voorraad",
  "Choose a selection...": "Kies een selectie...",
  "Choose your {option}": "Selecteer je {option}",
  "Free shipping": "Gratis bezorging",
  "Select one of the required options.": "Selecteer één van de verplichte opties.",
  "Add to cart": "In winkelmand",
  "Save": "Bewaren",
  "Remove": "Verwijderen",

  //Cart
  "Shopping cart": "Winkelwagen",
  "To checkout": "Bestellen",
  "Secure connection": "Bij ons betaal je veilig",
  "Continue shopping": "Verder winkelen",
  "You have no product(s) in your shopping cart.": "Je hebt geen product(en) in je winkelwagen.",
  "Click {url} to continue shopping": "Klik {url} om verder te gaan met winkelen.",
  "here": "hier",
  "Loading shopping cart items...": "Winkelmandje aan het laden...",
  "Other customers also bought": "Andere klanten kochten ook",
  "Description": "Omschrijving",
  "Quantity": "Aantal",
  "Unit price": "Stukprijs",
  "Subtotal": "Subtotaal",
  "SKU": "Artikelnummer",
  "Shipping costs": "Verzendkosten",

  //Checkout
  "Address": "Gegevens",
  "Address and shipping": "Gegevens en bezorging",
  "Billing address": "Factuurgegevens",
  "Shipping address": "Bezorgadres",
  "Shipping": "Bezorging",
  "Payment": "Betaling",
  "Back to cart": "Terug naar winkelwagen",
  "To shipping": "Naar bezorging",
  "To payment": "Naar betaling",
  "Complete order": "Afrekenen",
  "Name": "Voornaam",
  "Last name": "Achternaam",
  "Company": "Bedrijf",
  "Country": "Land",
  "Choose your country": "Kies je land",
  "Choose your bank": "Kies je bank",
  "Street": "Straat",
  "House number": "Huisnummer",
  "House no.": "Huisnr",
  "Addition": "Toevoeging",
  "Add.": "Toev.",
  "Postal code": "Postcode",
  "City": "Plaats",
  "Telephone": "Telefoon",
  "Billing address is different from the address above": "Factuuradres is anders dan bovenstaand adres",
  "Email address": "E-mail adres",
  "Password": "Wachtwoord",
  "You have an account. Would you like to {action}?": "Je hebt een account. Wil je {action}?",
  "login": "inloggen",
  "Log in": "Inloggen",
  "Forgot password?": "Wachtwoord vergeten?",
  "Add new address": "Nieuw adres toevoegen",
  "Select your address": "Selecteer je gewenste adres",
  "The most used payment method in The Netherlands": "De meest gebruikte betaalmethode in Nederland",
  "Without extra fees": "Zonder extra kosten",
  "Payment methods": "Betaalmethode",
  "Payment method": "Betaalmethode",
  "Shipping methods": "Afhalen of bezorgen",
  "Shipping method": "Bezorgmethode",
  "Fill in your address to see the available shipping methods.": "Vul je adres in om de beschikbare bezorgmethodes te zien.",
  "Overview of your order": "Overzicht van je bestelling",
  "Items": "Artikelen",
  "Cart totals": "Totaal overzicht",
  "Free": "Gratis",
  "Your order will be delivered on": "Je bestelling wordt bezorgd op",
  "You can pick up your order at": "Je kunt je bestelling ophalen op",
  "Change delivery address": "Wijzig bezorgadres",
  "Change pickup point": "Wijzig ophaalpunt",
  "Choose a delivery date": "Kies een bezorgdatum",
  "I have a discount code": "Ik heb een kortingscode",
  "Apply": "Toepassen",
  "Cancel": "Annuleren",
  "Your applied coupon code is {couponCodeInput}.": "Je toegepaste kortingscode is {couponCodeInput}.",
  "Business order": "Zakelijk bestellen?",
  "VAT Number": "BTW-nummer",
  "Chamber of Commerce number": "KvK-nummer",
  "Sign up for the newsletter": "Aanmelden voor de nieuwsbrief",
  "We have found the following address": "We hebben het volgende adres gevonden",
  "Invalid address. Are you sure it is correct?": "Ongeldig adres. Weet je zeker dat dit klopt?",
  "Click here to enter the address manually.": "Klik hier om het adres handmatig in te vullen.",
  "Click here to automatically retrieve your address": "Klik hier om je adres automatisch op te zoeken",
  "Home delivery": "Thuisbezorging",
  "Pick up at a PostNL point": "Afhalen bij een PostNL-punt",
  "Choose a pickup point": "Kies een ophaalpunt",
  "Please choose a pickup point.": "Kies een ophaalpunt om verder te gaan.",
  "Please choose a delivery date.": "Kies een bezorgdatum om verder te gaan.",
  "Ready for pickup from": "Klaar voor ophalen vanaf",
  "No pickup points found for this address.": "Geen ophaalpunten gevonden voor dit adres.",
  "Enter a valid postcode and house number first so we can show the delivery options.": "Vul eerst een geldige postcode en huisnummer in, zodat we de bezorgopties kunnen tonen.",
  "Delivery options could not be loaded. Please check your address and try again.": "Bezorgopties konden niet worden geladen. Controleer je adres en probeer het opnieuw.",
  "Order comments": "Opmerkingen",
  "Comments on your order": "Opmerkingen bij je bestelling",
  "Any comments about your order?": "Heb je nog opmerkingen bij je bestelling?",
  "The VAT number is valid.": "Het BTW-nummer is geldig.",
  "The VAT number is invalid.": "Het BTW-nummer is ongeldig.",
  "The VAT number could not be validated at this time.": "Het BTW-nummer kon op dit moment niet gevalideerd worden.",
  "Please enter a valid VAT number, including the country code (e.g. NL123456789B01).": "Vul een geldig BTW-nummer in, inclusief landcode (bijv. NL123456789B01).",
  "optional": "optioneel",
  "inclusief btw": "Incl. btw",
  "(incl. VAT)": "Incl. btw",
  "Total excl. VAT": "Totaal (excl. BTW)",
  "Total incl. VAT": "Totaal (incl. BTW)",
  "VAT ({percent}%)": "BTW ({percent}%)",
  "VAT": "BTW",
  "VAT reversed": "BTW verlegd",
  "Discount": "Korting",
  "Evening": "Avondlevering",
  "Sameday": "Zelfde dag",
  "Morning": "Ochtend",
  "Open today": "Vandaag open",
  "Opening hours": "Openingstijden",
  "Monday": "Maandag",
  "Tuesday": "Dinsdag",
  "Wednesday": "Woensdag",
  "Thursday": "Donderdag",
  "Friday": "Vrijdag",
  "Saturday": "Zaterdag",
  "Sunday": "Zondag",
  "Unable to start the payment, please try again later.": "Betaling starten is nu niet mogelijk, probeer het later opnieuw.",
  "Unable to place order, please try again later.": "Bestelling plaatsen is nu niet mogelijk, probeer het later opnieuw.",

  //Product siblings
  "Color": "Kleur",
  "Finish": "Uitvoering",
  "{name} (out of stock)": "{name} (uitverkocht)",
}
